import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { TenantDashboard } from '@/features/tenants/TenantDashboard';
import { useTenant } from '@/lib/tenant';

function TenantDashboardRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <TenantDashboard slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/')({
  component: TenantDashboardRoute,
});
